import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LojistikFiyatArsiv } from 'src/model/lojistik-fiyat-arsiv';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-fiyat-arsiv-liste',
  templateUrl: './lojistik-fiyat-arsiv-liste.component.html',
  styleUrls: ['./lojistik-fiyat-arsiv-liste.component.css']
})
export class LojistikFiyatArsivListeComponent implements OnInit {

  fiyatlar: LojistikFiyatArsiv[];
  
  @Output() updateFiyatlar = new EventEmitter<boolean>();

  @Input()
  public set source(fiyatlar: LojistikFiyatArsiv[]) {
    if (fiyatlar != null) {
      this.fiyatlar = fiyatlar;
    }
  }
  constructor(private router: Router, private restService: RestService) { }

  ngOnInit() {
  }

  incele(id: number) {
    this.router.navigate(['lojistik-fiyat-arsiv-olustur'], { queryParams: { id: id } });
  }

  sil(f: LojistikFiyatArsiv) {
    if (confirm("Silmek istediğinize emin misiniz?")) {
      this.restService.lojistikFiyatSil(f).subscribe(res => {
        if (res) {
          this.updateFiyatlar.emit(true);
        }
      });
    }
  }
}
